<template>
    <!-- 表格组件 -->
    <div class="vel-table">
        <!-- 搜索插槽 -->
        <slot name="search"></slot>
        <el-table
        :data="tableData"
        :border="border"
        :stripe="stripe"
        :show-summary="showSummary"
        :row-key="rowkey"
        :lazy="lazy"
        :load="load"
        :highlight-current-row="highlightCurrentRow"
        :tree-props="treeProps"
        :max-height="maxHeight"
        :height="height"
        @selection-change="selectChange"
        @header-click="headerClick"
        style="width: 100%">
            <!-- 展开行数据 -->
            <el-table-column v-if="expand" :width="specialWidth" label="展开" type="expand" fixed="left">
                <template slot-scope="{row}">
                    <slot name="expand" :row="row">{{row}}</slot>
                </template>
            </el-table-column>
            <!-- 表格序号 -->
            <el-table-column v-if="index" :width="specialWidth" label="序号" type="index" :index="indexMethod" fixed="left" />
            <!-- 表格多选 -->
            <el-table-column v-if="selection" type="selection" fixed="left" /> 
            <!-- 列表数据 -->
            <template v-for="column in showColumns">
                <!-- 多级表头展示 -->
                <VelDeepColumn v-if="column.hander" :column="column" :key="column.prop"/>
                <!-- 单个表头展示 -->
                <el-table-column 
                v-else
                :prop="column.prop" 
                :label="column.label" 
                :width="column.width" 
                :key="column.prop" 
                :align="column.align"
                :fixed="column.fixed"
                :sortable="column.sortable"
                >
                    <template slot-scope="{row}">
                        <div style="display:inline-block">
                            <!-- 是否开启列表插槽 -->
                            <template v-if="column.slot">
                                <slot :name="column.prop" :row="row"></slot>
                            </template>
                            <!-- 是否开启提示和编译 -->
                            <VelTips
                            v-else-if="column.isTips&&column.isCompile" 
                            :effect="column.isTips.effect?column.isTips.effect:'light'" 
                            :content="column.isCompile(row[column.prop])" placement="top">
                                <span class="tips">
                                    {{column.isCompile(row[column.prop])}}
                                </span>
                            </VelTips>
                            <!-- 是否开启编译 -->
                            <span v-else-if="column.isCompile" >{{column.isCompile(row[column.prop])}}</span>
                            <!-- 是否开启插入Html -->
                            <span v-else-if="column.isHtml" v-html="column.isHtml(row[column.prop])" />
                            <!-- 是否开启提示 -->
                            <VelTips
                            v-else-if="column.isTips" 
                            :effect="column.isTips.effect?column.isTips.effect:'light'" 
                            :content="row[column.prop]" placement="top">
                                <span class="tips">
                                    {{row[column.prop]}}
                                </span>
                            </VelTips>
                            <!-- 是否是删除 -->
                            <div v-else-if="!column.prop" style="display:flex;align-items:center;">
                                <slot :row="row">
                                    <Vel-btn 
                                    v-if="column?.action?.edit ? column?.action?.edit : true" 
                                    style="margin-right:10px"
                                    type="text" 
                                    icon="el-icon-edit" 
                                    btnText="编辑"
                                    @btnClick="actionFn('edit',row)" />
                                    <VelPopover @show="actionDelFn('confirm')" @hide="actionDelFn('cancel')">
                                        <VelBtn
                                        v-if="column?.action?.del ? column?.action?.del : true"
                                        slot="reference"
                                        style="margin-right:10px"
                                        type="text" 
                                        icon="el-icon-delete" 
                                        btnText="删除"
                                        @btnClick="actionFn('del',row)"/>
                                    </VelPopover>
                                    <!-- 更多操作 -->
                                    <el-dropdown v-if="column?.action?.more ? column?.action?.more : true" >
                                        <span style="color:#409EFF;">
                                            更多<VelIcon iconName="el-icon-arrow-down el-icon--right" />
                                        </span>
                                        <!-- 下拉列表 -->
                                        <el-dropdown-menu slot="dropdown">
                                            <template v-for="(dr,dinx) in dropdownList">
                                                <el-dropdown-item
                                                :disabled="dr.disabled"
                                                :divided="dr.divided"
                                                :command="dr.command"
                                                :key="dr.text + dinx"
                                                @click.native="actionFn(dr.command,row)"
                                                >
                                                    <slot v-if="dr.slot" :name="dr.slot" :row="dr" ></slot>
                                                    <VelIcon v-else :iconName="dr.icon" :iconText="dr.text" />
                                                </el-dropdown-item>
                                            </template>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </slot>
                            </div>
                            <!-- 普通列表 -->
                            <span v-else>{{row[column.prop]}}</span>
                        </div>
                    </template>
                </el-table-column>
            </template>

            <el-empty slot="empty" :image-size="200" />
        </el-table>
        <!-- 底部插槽 -->
        <slot name="footer"></slot>
    </div>
</template>
<script>
import VelBtn from '../button'
import VelTips from '../tips'
import VelDeepColumn from '../tablecolumn'
import VelIcon from '../icon'
import VelPopover from '../popover'
export default {
    name:"VelTable",
    components:{
        VelBtn,
        VelTips,
        VelDeepColumn,
        VelIcon,
        VelPopover
    },
    props:{
        indexMethod:Function,
        tableData:{
            type:Array,
            required:true,
        },
        rowkey:{
            type:[String,Function],
            default:'id'
        },
        load:Function,
        treeProps:{
            type:Object,
            default:() =>{
                return {children: 'children', hasChildren: 'hasChildren'}
            }
        },
        height:{
            type:[Number,String]
        },
        maxHeight:{
            type:[Number,String],
            default:400
        },
        columns:{
            type:Array,
            required:true,
        },
        specialWidth:{
            type:[Number,String],
            default: '50'
        },
        dropdownList:{
            default:() =>{
                return [
                    {command:'more',text:'详情',icon:'el-icon-info'}
                ]
            }
        },
        isBorder:Boolean,
        isStripe:Boolean,
        isSelection:Boolean,
        isShowSummary:Boolean,
        isHighlightCurrentRow:Boolean,
        isExpand:Boolean,
        isIndex:Boolean,
        isLazy:Boolean,
    },
    data() {
        return {
            /* column值 
            hander:{label:"",columns:[]} hander多级表头 label表头名columns 表头中的列配置
            prop 列配置字段
            label 列配置名称
            width 列配置宽度
            hidden 列配置是否隐藏
            isCompile 列配置编译方法
            align 列配置对其方式
            slot 列配置插槽
            fixed 列配置固定方式
            isTips:{effect:"",max:number,slice:number} 是否提示 effect提示颜色 max最大长度 slice截取长度
            isShow:{hideEdit:true,hideDel:true} hideEidt 隐藏编辑 hideDel 隐藏删除
            列配置中只有hander为多表头，列配置没有prop为操作 
            */
            action:null,
            showSummary:false,
            lazy:false,
            highlightCurrentRow:false,
            expand:false,
            index:false,
            border:true,
            stripe:true,
            selection:true,
        };
    },
    created(){
        this.action = this.showColumns[this.showColumns.length-1]
        this.initDataFn()
    },
    computed:{
        showColumns(){
            return this.columns.filter(column => !column.hidden)
        },
    },
    methods: {
        initDataFn(){
            this.isShowSummary ? this.showSummary = true : this.showSummary
            this.isHighlightCurrentRow ? this.showSummary = true : this.showSummary
            this.isExpand ? this.expand = true : this.expand
            this.isIndex ? this.index = true : this.index
            this.isLazy ? this.lazy = true : this.lazy
            this.isBorder ? this.border = false : this.border
            this.isStripe ? this.stripe = false : this.stripe
            this.isSelection ? this.selection = false : this.selection
        },
        // indexMethods(index) {
        //     const page = this.page // 单前页码
        //     const size = this.size // 每页条数
        //     return (index + 1) + (page - 1) * size
        // },
        selectChange(select){
            this.$emit('selectChange',select)
        },
        headerClick({property}){
            this.$emit('headerClick',property)
        },
        actionFn(type,row){
            this.$emit('actionFn',type,row)
        },
        actionDelFn(type){
            this.$emit('actionDelFn',type)
        },
    },
}
</script>
<style scoped>
.vel-table{
    width: 100%;
}
.tips{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
::v-deep .el-table--border th.el-table__cell, 
.el-table__fixed-right-patch {
    background: #F5F7FA;
}
::v-deep .el-table th.el-table__cell{
    background: #F5F7FA;
}
</style>